/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as CheckInRouteImport } from './routes/check-in'
import { Route as DownloadRouteImport } from './routes/download'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MiniTimerRouteImport } from './routes/mini-timer'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppAttendanceRouteImport } from './routes/_app/attendance'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppClockRouteImport } from './routes/_app/clock'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppIdeasRouteImport } from './routes/_app/ideas'
import { Route as AppMeRouteImport } from './routes/_app/me'
import { Route as AppMyDayRouteImport } from './routes/_app/my-day'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppTasksRouteImport } from './routes/_app/tasks'
import { Route as AppTeamRouteImport } from './routes/_app/team'
import { Route as AppTeamsRouteImport } from './routes/_app/teams'
import { Route as ConnectClaudeRouteImport } from './routes/connect.claude'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AppChatIndexRouteImport } from './routes/_app/chat/index'
import { Route as AppChatIdRouteImport } from './routes/_app/chat/$id'
import { Route as AppChatSavedRouteImport } from './routes/_app/chat/saved'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders/index'
import { Route as AppPeopleIndexRouteImport } from './routes/_app/people/index'
import { Route as AppPeopleIdRouteImport } from './routes/_app/people/$id'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsIdRouteImport } from './routes/_app/projects/$id'
import { Route as AppOrdersSpaceIdIndexRouteImport } from './routes/_app/orders/$spaceId.index'
import { Route as AppOrdersSpaceIdOrderIdRouteImport } from './routes/_app/orders/$spaceId.$orderId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckInRoute = CheckInRouteImport.update({
  id: '/check-in',
  path: '/check-in',
  getParentRoute: () => rootRouteImport,
} as any)
const DownloadRoute = DownloadRouteImport.update({
  id: '/download',
  path: '/download',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MiniTimerRoute = MiniTimerRouteImport.update({
  id: '/mini-timer',
  path: '/mini-timer',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppAttendanceRoute = AppAttendanceRouteImport.update({
  id: '/attendance',
  path: '/attendance',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppClockRoute = AppClockRouteImport.update({
  id: '/clock',
  path: '/clock',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppIdeasRoute = AppIdeasRouteImport.update({
  id: '/ideas',
  path: '/ideas',
  getParentRoute: () => AppRoute,
} as any)
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any)
const AppMyDayRoute = AppMyDayRouteImport.update({
  id: '/my-day',
  path: '/my-day',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamRoute = AppTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamsRoute = AppTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppRoute,
} as any)
const ConnectClaudeRoute = ConnectClaudeRouteImport.update({
  id: '/connect/claude',
  path: '/connect/claude',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatRoute,
} as any)
const AppChatIdRoute = AppChatIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppChatRoute,
} as any)
const AppChatSavedRoute = AppChatSavedRouteImport.update({
  id: '/saved',
  path: '/saved',
  getParentRoute: () => AppChatRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleIndexRoute = AppPeopleIndexRouteImport.update({
  id: '/people/',
  path: '/people/',
  getParentRoute: () => AppRoute,
} as any)
const AppPeopleIdRoute = AppPeopleIdRouteImport.update({
  id: '/people/$id',
  path: '/people/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsIdRoute = AppProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersSpaceIdIndexRoute = AppOrdersSpaceIdIndexRouteImport.update({
  id: '/orders/$spaceId/',
  path: '/orders/$spaceId/',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersSpaceIdOrderIdRoute = AppOrdersSpaceIdOrderIdRouteImport.update({
  id: '/orders/$spaceId/$orderId',
  path: '/orders/$spaceId/$orderId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/check-in': typeof CheckInRoute
  '/download': typeof DownloadRoute
  '/login': typeof LoginRoute
  '/mini-timer': typeof MiniTimerRoute
  '/privacy': typeof PrivacyRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/attendance': typeof AppAttendanceRoute
  '/calendar': typeof AppCalendarRoute
  '/chat': typeof AppChatRouteWithChildren
  '/clock': typeof AppClockRoute
  '/dashboard': typeof AppDashboardRoute
  '/ideas': typeof AppIdeasRoute
  '/me': typeof AppMeRoute
  '/my-day': typeof AppMyDayRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/teams': typeof AppTeamsRoute
  '/connect/claude': typeof ConnectClaudeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/chat/$id': typeof AppChatIdRoute
  '/chat/saved': typeof AppChatSavedRoute
  '/people/$id': typeof AppPeopleIdRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/chat/': typeof AppChatIndexRoute
  '/orders/': typeof AppOrdersIndexRoute
  '/people/': typeof AppPeopleIndexRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/orders/$spaceId/$orderId': typeof AppOrdersSpaceIdOrderIdRoute
  '/orders/$spaceId/': typeof AppOrdersSpaceIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/check-in': typeof CheckInRoute
  '/download': typeof DownloadRoute
  '/login': typeof LoginRoute
  '/mini-timer': typeof MiniTimerRoute
  '/privacy': typeof PrivacyRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/analytics': typeof AppAnalyticsRoute
  '/attendance': typeof AppAttendanceRoute
  '/calendar': typeof AppCalendarRoute
  '/clock': typeof AppClockRoute
  '/dashboard': typeof AppDashboardRoute
  '/ideas': typeof AppIdeasRoute
  '/me': typeof AppMeRoute
  '/my-day': typeof AppMyDayRoute
  '/reports': typeof AppReportsRoute
  '/settings': typeof AppSettingsRoute
  '/tasks': typeof AppTasksRoute
  '/team': typeof AppTeamRoute
  '/teams': typeof AppTeamsRoute
  '/connect/claude': typeof ConnectClaudeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/chat/$id': typeof AppChatIdRoute
  '/chat/saved': typeof AppChatSavedRoute
  '/people/$id': typeof AppPeopleIdRoute
  '/projects/$id': typeof AppProjectsIdRoute
  '/chat': typeof AppChatIndexRoute
  '/orders': typeof AppOrdersIndexRoute
  '/people': typeof AppPeopleIndexRoute
  '/projects': typeof AppProjectsIndexRoute
  '/orders/$spaceId/$orderId': typeof AppOrdersSpaceIdOrderIdRoute
  '/orders/$spaceId': typeof AppOrdersSpaceIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/check-in': typeof CheckInRoute
  '/download': typeof DownloadRoute
  '/login': typeof LoginRoute
  '/mini-timer': typeof MiniTimerRoute
  '/privacy': typeof PrivacyRoute
  '/signup': typeof SignupRoute
  '/terms': typeof TermsRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/attendance': typeof AppAttendanceRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/chat': typeof AppChatRouteWithChildren
  '/_app/clock': typeof AppClockRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/ideas': typeof AppIdeasRoute
  '/_app/me': typeof AppMeRoute
  '/_app/my-day': typeof AppMyDayRoute
  '/_app/reports': typeof AppReportsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/tasks': typeof AppTasksRoute
  '/_app/team': typeof AppTeamRoute
  '/_app/teams': typeof AppTeamsRoute
  '/connect/claude': typeof ConnectClaudeRoute
  '/invite/$token': typeof InviteTokenRoute
  '/_app/chat/$id': typeof AppChatIdRoute
  '/_app/chat/saved': typeof AppChatSavedRoute
  '/_app/people/$id': typeof AppPeopleIdRoute
  '/_app/projects/$id': typeof AppProjectsIdRoute
  '/_app/chat/': typeof AppChatIndexRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
  '/_app/people/': typeof AppPeopleIndexRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/orders/$spaceId/$orderId': typeof AppOrdersSpaceIdOrderIdRoute
  '/_app/orders/$spaceId/': typeof AppOrdersSpaceIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/check-in'
    | '/download'
    | '/login'
    | '/mini-timer'
    | '/privacy'
    | '/signup'
    | '/terms'
    | '/analytics'
    | '/attendance'
    | '/calendar'
    | '/chat'
    | '/clock'
    | '/dashboard'
    | '/ideas'
    | '/me'
    | '/my-day'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/teams'
    | '/connect/claude'
    | '/invite/$token'
    | '/chat/$id'
    | '/chat/saved'
    | '/people/$id'
    | '/projects/$id'
    | '/chat/'
    | '/orders/'
    | '/people/'
    | '/projects/'
    | '/orders/$spaceId/$orderId'
    | '/orders/$spaceId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/check-in'
    | '/download'
    | '/login'
    | '/mini-timer'
    | '/privacy'
    | '/signup'
    | '/terms'
    | '/analytics'
    | '/attendance'
    | '/calendar'
    | '/clock'
    | '/dashboard'
    | '/ideas'
    | '/me'
    | '/my-day'
    | '/reports'
    | '/settings'
    | '/tasks'
    | '/team'
    | '/teams'
    | '/connect/claude'
    | '/invite/$token'
    | '/chat/$id'
    | '/chat/saved'
    | '/people/$id'
    | '/projects/$id'
    | '/chat'
    | '/orders'
    | '/people'
    | '/projects'
    | '/orders/$spaceId/$orderId'
    | '/orders/$spaceId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/check-in'
    | '/download'
    | '/login'
    | '/mini-timer'
    | '/privacy'
    | '/signup'
    | '/terms'
    | '/_app/analytics'
    | '/_app/attendance'
    | '/_app/calendar'
    | '/_app/chat'
    | '/_app/clock'
    | '/_app/dashboard'
    | '/_app/ideas'
    | '/_app/me'
    | '/_app/my-day'
    | '/_app/reports'
    | '/_app/settings'
    | '/_app/tasks'
    | '/_app/team'
    | '/_app/teams'
    | '/connect/claude'
    | '/invite/$token'
    | '/_app/chat/$id'
    | '/_app/chat/saved'
    | '/_app/people/$id'
    | '/_app/projects/$id'
    | '/_app/chat/'
    | '/_app/orders/'
    | '/_app/people/'
    | '/_app/projects/'
    | '/_app/orders/$spaceId/$orderId'
    | '/_app/orders/$spaceId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  CheckInRoute: typeof CheckInRoute
  DownloadRoute: typeof DownloadRoute
  LoginRoute: typeof LoginRoute
  MiniTimerRoute: typeof MiniTimerRoute
  PrivacyRoute: typeof PrivacyRoute
  SignupRoute: typeof SignupRoute
  TermsRoute: typeof TermsRoute
  ConnectClaudeRoute: typeof ConnectClaudeRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/check-in': {
      id: '/check-in'
      path: '/check-in'
      fullPath: '/check-in'
      preLoaderRoute: typeof CheckInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/download': {
      id: '/download'
      path: '/download'
      fullPath: '/download'
      preLoaderRoute: typeof DownloadRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mini-timer': {
      id: '/mini-timer'
      path: '/mini-timer'
      fullPath: '/mini-timer'
      preLoaderRoute: typeof MiniTimerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/attendance': {
      id: '/_app/attendance'
      path: '/attendance'
      fullPath: '/attendance'
      preLoaderRoute: typeof AppAttendanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clock': {
      id: '/_app/clock'
      path: '/clock'
      fullPath: '/clock'
      preLoaderRoute: typeof AppClockRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ideas': {
      id: '/_app/ideas'
      path: '/ideas'
      fullPath: '/ideas'
      preLoaderRoute: typeof AppIdeasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/me': {
      id: '/_app/me'
      path: '/me'
      fullPath: '/me'
      preLoaderRoute: typeof AppMeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-day': {
      id: '/_app/my-day'
      path: '/my-day'
      fullPath: '/my-day'
      preLoaderRoute: typeof AppMyDayRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tasks': {
      id: '/_app/tasks'
      path: '/tasks'
      fullPath: '/tasks'
      preLoaderRoute: typeof AppTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team': {
      id: '/_app/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AppTeamRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/teams': {
      id: '/_app/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AppTeamsRouteImport
      parentRoute: typeof AppRoute
    }
    '/connect/claude': {
      id: '/connect/claude'
      path: '/connect/claude'
      fullPath: '/connect/claude'
      preLoaderRoute: typeof ConnectClaudeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/chat/': {
      id: '/_app/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/_app/chat/$id': {
      id: '/_app/chat/$id'
      path: '/$id'
      fullPath: '/chat/$id'
      preLoaderRoute: typeof AppChatIdRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/_app/chat/saved': {
      id: '/_app/chat/saved'
      path: '/saved'
      fullPath: '/chat/saved'
      preLoaderRoute: typeof AppChatSavedRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/': {
      id: '/_app/people/'
      path: '/people'
      fullPath: '/people/'
      preLoaderRoute: typeof AppPeopleIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/people/$id': {
      id: '/_app/people/$id'
      path: '/people/$id'
      fullPath: '/people/$id'
      preLoaderRoute: typeof AppPeopleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$id': {
      id: '/_app/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof AppProjectsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$spaceId/': {
      id: '/_app/orders/$spaceId/'
      path: '/orders/$spaceId'
      fullPath: '/orders/$spaceId/'
      preLoaderRoute: typeof AppOrdersSpaceIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/$spaceId/$orderId': {
      id: '/_app/orders/$spaceId/$orderId'
      path: '/orders/$spaceId/$orderId'
      fullPath: '/orders/$spaceId/$orderId'
      preLoaderRoute: typeof AppOrdersSpaceIdOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppChatRouteChildren {
  AppChatIdRoute: typeof AppChatIdRoute
  AppChatSavedRoute: typeof AppChatSavedRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
}

const AppChatRouteChildren: AppChatRouteChildren = {
  AppChatIdRoute: AppChatIdRoute,
  AppChatSavedRoute: AppChatSavedRoute,
  AppChatIndexRoute: AppChatIndexRoute,
}

const AppChatRouteWithChildren =
  AppChatRoute._addFileChildren(AppChatRouteChildren)

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppAttendanceRoute: typeof AppAttendanceRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppChatRoute: typeof AppChatRouteWithChildren
  AppClockRoute: typeof AppClockRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppIdeasRoute: typeof AppIdeasRoute
  AppMeRoute: typeof AppMeRoute
  AppMyDayRoute: typeof AppMyDayRoute
  AppReportsRoute: typeof AppReportsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppTasksRoute: typeof AppTasksRoute
  AppTeamRoute: typeof AppTeamRoute
  AppTeamsRoute: typeof AppTeamsRoute
  AppPeopleIdRoute: typeof AppPeopleIdRoute
  AppProjectsIdRoute: typeof AppProjectsIdRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
  AppPeopleIndexRoute: typeof AppPeopleIndexRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppOrdersSpaceIdOrderIdRoute: typeof AppOrdersSpaceIdOrderIdRoute
  AppOrdersSpaceIdIndexRoute: typeof AppOrdersSpaceIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppAttendanceRoute: AppAttendanceRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppChatRoute: AppChatRouteWithChildren,
  AppClockRoute: AppClockRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppIdeasRoute: AppIdeasRoute,
  AppMeRoute: AppMeRoute,
  AppMyDayRoute: AppMyDayRoute,
  AppReportsRoute: AppReportsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppTasksRoute: AppTasksRoute,
  AppTeamRoute: AppTeamRoute,
  AppTeamsRoute: AppTeamsRoute,
  AppPeopleIdRoute: AppPeopleIdRoute,
  AppProjectsIdRoute: AppProjectsIdRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
  AppPeopleIndexRoute: AppPeopleIndexRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppOrdersSpaceIdOrderIdRoute: AppOrdersSpaceIdOrderIdRoute,
  AppOrdersSpaceIdIndexRoute: AppOrdersSpaceIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  CheckInRoute: CheckInRoute,
  DownloadRoute: DownloadRoute,
  LoginRoute: LoginRoute,
  MiniTimerRoute: MiniTimerRoute,
  PrivacyRoute: PrivacyRoute,
  SignupRoute: SignupRoute,
  TermsRoute: TermsRoute,
  ConnectClaudeRoute: ConnectClaudeRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
